import React from 'react';

import {WorkflowDashboardDetails, WorkflowStatus} from '../WorkflowConstants';

interface WorkflowStatusSpanProps {
  workflowDashboardDetails: WorkflowDashboardDetails;
}

export default function WorkflowStatusSpan(props: WorkflowStatusSpanProps): JSX.Element {
  if (props.workflowDashboardDetails.status === WorkflowStatus.DRAFT) {
    return <span>Draft</span>;
  } else if (props.workflowDashboardDetails.status === WorkflowStatus.COMPLETED) {
    return <span className="u-success-color">Completed</span>;
  } else if (props.workflowDashboardDetails.lastStageCompletionChange) {
    return <span>{props.workflowDashboardDetails.lastStageCompletionChange.stageName}</span>;
  } else {
    return <span>Initialized</span>;
  }
}
